import { Modal } from '@warp-ds/react';
import { useModalSizingHelper } from '../../hooks/useModalSizingHelper.js';

type RegtaxInfoModalProps = {
  open: boolean;
  onDismiss: () => void;
};

export const RegtaxInfoModal = ({ open, onDismiss }: RegtaxInfoModalProps) => {
  const modalStyles = useModalSizingHelper();

  return (
    <Modal title="Omregistreringsavgift" open={open} right={true} onDismiss={onDismiss} style={modalStyles}>
      <div className="mb-32">
        <div>
          <p className="mt-16">
            Som selger er du ansvarlig for at opplysningene i annonsen er korrekte. Vi anbefaler derfor at du
            kontrollerer at omregistreringsavgiften i annonsen er i henhold til tabellen under.
          </p>
          <p>Kjøretøy som er 30 år eller eldre er fritatt omregistreringsavgift.</p>
          <p>Tabellen viser gjeldende satser fra 1. januar 2026.</p>
          <div className="grid grid-cols-2 gap-32 mt-16">
            <div>
              <h3>Personbiler (t.o.m. 1 200 kg)</h3>
              <hr className="my-16" />
              <table className="w-full">
                <thead>
                  <tr>
                    <th className="text-left">Årstall</th>
                    <th className="text-right">Pris kr.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-left">Opp til 2014</td>
                    <td className="text-right">1&nbsp;942,-</td>
                  </tr>
                  <tr>
                    <td className="text-left">2015 - 2022</td>
                    <td className="text-right">3&nbsp;236,-</td>
                  </tr>
                  <tr>
                    <td className="text-left">2023 - 2026</td>
                    <td className="text-right">4&nbsp;918,-</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <h3>Personbiler (over 1 200 kg)</h3>
              <hr className="my-16" />
              <table className="w-full">
                <thead>
                  <tr>
                    <th className="text-left">Årstall</th>
                    <th className="text-right">Pris kr.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-left">Opp til 2014</td>
                    <td className="text-right">1&nbsp;942,-</td>
                  </tr>
                  <tr>
                    <td className="text-left">2015 - 2022</td>
                    <td className="text-right">4&nbsp;532,-</td>
                  </tr>
                  <tr>
                    <td className="text-left">2023 - 2026</td>
                    <td className="text-right">7&nbsp;505,-</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <h3>Mopeder, motorsykler og beltemotorsykler</h3>
              <hr className="my-16" />
              <table className="w-full">
                <thead>
                  <tr>
                    <th className="text-left">Årstall</th>
                    <th className="text-right">Pris kr.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-left">Opp til 2014</td>
                    <td className="text-right">645,-</td>
                  </tr>
                  <tr>
                    <td className="text-left">2015 - 2022</td>
                    <td className="text-right">645,-</td>
                  </tr>
                  <tr>
                    <td className="text-left">2023 - 2026</td>
                    <td className="text-right">645,-</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <h3>
                Lastebiler, trekkbiler, varebiler, kombinerte biler, campingbiler, beltebiler og busser med tillatt
                totalvekt inntil 7 500 kg
              </h3>
              <hr className="my-16" />
              <table className="w-full">
                <thead>
                  <tr>
                    <th className="text-left">Årstall</th>
                    <th className="text-right">Pris kr.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-left">Opp til 2014</td>
                    <td className="text-right">1&nbsp;296,-</td>
                  </tr>
                  <tr>
                    <td className="text-left">2015 - 2022</td>
                    <td className="text-right">1&nbsp;553,-</td>
                  </tr>
                  <tr>
                    <td className="text-left">2023 - 2026</td>
                    <td className="text-right">2&nbsp;459,-</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <h3>
                Biltilhengere, herunder semitrailere og campingtilhengere, med egenvekt (typegodkjent) over 350 kg
              </h3>
              <hr className="my-16" />
              <table className="w-full">
                <thead>
                  <tr>
                    <th className="text-left">Årstall</th>
                    <th className="text-right">Pris kr.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-left">Opp til 2014</td>
                    <td className="text-right">645,-</td>
                  </tr>
                  <tr>
                    <td className="text-left">2015 - 2022</td>
                    <td className="text-right">645,-</td>
                  </tr>
                  <tr>
                    <td className="text-left">2023 - 2026</td>
                    <td className="text-right">645,-</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
